import { NUMBER_400, NUMBER_401, NUMBER_403, NUMBER_404, NUMBER_412, NUMBER_424, NUMBER_500 } from '~shared/constants';

export enum HttpErrorStatuses {
  BadRequest = NUMBER_400,
  Unauthorized = NUMBER_401,
  Forbidden = NUMBER_403,
  NotFound = NUMBER_404,
  IMSError = NUMBER_412,
  FailedDependency = NUMBER_424,
  ServerError = NUMBER_500,
}
